import AbstractRestApi from './AbstractRestApi'

class OrderHistoryApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/order-history'
    }
}

export default new OrderHistoryApiClient()
